import { FC } from 'react';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import { Column } from '../../Layout';

const Subtitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey[500],
  fontWeight: 400,
}));

type Props = {
  title: string;
  subtitle: string;
};

const LabelColumnHeader: FC<Props> = ({ title, subtitle }) => {
  return (
    <Column spacing="xs">
      <Typography variant="h6">{title}</Typography>
      <Subtitle>{subtitle}</Subtitle>
    </Column>
  );
};

export default LabelColumnHeader;
